import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=46758056&scoped=true&"
import script from "./LikeButton.vue?vue&type=script&lang=js&"
export * from "./LikeButton.vue?vue&type=script&lang=js&"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=46758056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46758056",
  null
  
)

export default component.exports